export const endpoints = {
  exchangeRate: '/exchange-rate',
  planet: {
    list: '/planets',
    detail: (id: string) => `/planets/${id}`,
  },
  transaction: {
    list: '/transactions',
    detail: (id: string) => `/transactions/${id}`,
    user: (userId: string) => `/transactions/user/${userId}`,
    users: (userIds: string) => `/transactions/users/${userIds}`,
    updateBatch: '/transactions/update-batch',
  },
  users: {
    list: '/users',
    detail: (id: string) => `/users/${id}`,
    planet: (planetId: string) => `/users/planet/${planetId}`,
  },
} as const;
